import {parsePhoneNumber} from "libphonenumber-js";
import {getNumberType} from "libphonenumber-js/custom";
import metadata from "libphonenumber-js/metadata.full.json";

export const validateCustomerData = (values, {translate}) => {
  const errors = {};
  if (!values.kiosk_id || values.kiosk_id.trim() === "") {
    errors.kiosk_id = translate("resources.customers.validation.storeName");
  }
  if (!values.first_name || values.first_name.trim() === "") {
    errors.first_name = translate("resources.customers.validation.firstName");
  }
  if (!values.last_name || values.last_name.trim() === "") {
    errors.last_name = translate("resources.customers.validation.lastName");
  }
  if (
    (!values.email || values.email.trim() === "") &&
    (!values.phone || values.phone.trim() === "")
  ) {
    errors.email = translate("resources.customers.validation.contact");
    errors.phone = translate("resources.customers.validation.contact");
  }

  return errors;
};

export const validatePhone = (value, allValues, props) => {
  if (value) {
    try {
      return parsePhoneNumber(value, "SE").isValid() &&
        parsePhoneNumber(value, "SE").isPossible() &&
        getNumberType(value, metadata) === "MOBILE"
        ? undefined
        : props.translate("resources.customers.validation.phone");
    } catch (error) {
      return props.translate("resources.customers.validation.phone");
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/Customers/validations.js